@if (mode() === 'detail') {
  <div class="detail-dialog">
    <!-- Header -->
    <div class="detail-header">
      <div class="header-actions">
        <button mat-icon-button (click)="switchToEdit()"
          *xuiPermissionRequired="'Clinical.Appointments.Write'"
          matTooltip="Edit">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="removeAppointment()"
          *xuiPermissionRequired="'Clinical.Appointments.Delete'"
          matTooltip="Delete">
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="header-content">
        <div class="header-info">
          <div class="patient-name">
            @if (appointment.patient?.status?.color) {
              <span class="patient-status-dot" [style.background-color]="appointment.patient.status.color"></span>
            }
            <span>{{ displayName }}</span>
          </div>
          <div class="date-time">{{ formattedDateTime }}</div>
        </div>
      </div>
    </div>

    <!-- Status Bar -->
    <div class="status-bar" [xuiInvertTextColor]="headerColor">
      <span class="status-text">{{ appointment.appointmentType?.title }}</span>
    </div>

    <!-- Content Area -->
    <div class="detail-content">
      @if (appointment.patient?.profileId) {
        <div class="detail-row">
          <mat-icon class="detail-icon">description</mat-icon>
          <span class="detail-label">File No:</span>
          <span class="detail-value">{{ appointment.patient.profileId.toString().padStart(4, '0') }}</span>
        </div>
      }
      @if (cellNumber) {
        <div class="detail-row">
          <mat-icon class="detail-icon">smartphone</mat-icon>
          <span class="detail-label">Cell:</span>
          <span class="detail-value">{{ cellNumber }}</span>
        </div>
      }
      @if (appointment.patient?.identityNumber) {
        <div class="detail-row">
          <mat-icon class="detail-icon">badge</mat-icon>
          <span class="detail-label">ID:</span>
          <span class="detail-value">{{ appointment.patient.identityNumber }}</span>
        </div>
      }
      @if (appointment.comment) {
        <div class="detail-row">
          <mat-icon class="detail-icon">chat_bubble_outline</mat-icon>
          <span class="detail-label">Reason:</span>
          <span class="detail-value">{{ appointment.comment }}</span>
        </div>
      }
      @if (email) {
        <div class="detail-row">
          <mat-icon class="detail-icon">email</mat-icon>
          <span class="detail-label">Email:</span>
          <span class="detail-value">{{ email }}</span>
        </div>
      }
      @if (!hasPatient && appointment.metaData?.name) {
        <div class="detail-row">
          <mat-icon class="detail-icon">person</mat-icon>
          <span class="detail-label">Name:</span>
          <span class="detail-value">{{ appointment.metaData.name }}</span>
        </div>
      }
      @if (appointment.patient?.flags?.length) {
        <div class="detail-row flags-row">
          <mat-icon class="detail-icon">label</mat-icon>
          <span class="detail-label">Lists:</span>
          <span class="flag-pills">
            @for (flag of appointment.patient.flags; track flag.id) {
              <span class="flag-pill" [style.background-color]="flag.color" [xuiInvertTextColor]="flag.color">{{ flag.name }}</span>
            }
          </span>
        </div>
      }
    </div>

    <!-- Footer Actions -->
    <div class="detail-footer">
      <button mat-stroked-button (click)="viewPatient()"
        *xuiPermissionRequired="'Clinical.Patients.Read'; condition: isPatientAppointment && hasPatient">
        <mat-icon>open_in_new</mat-icon>
        View Profile
      </button>
      <button mat-stroked-button (click)="viewPatientClinical()"
        *xuiPermissionRequired="'Clinical.Patients.Read'; condition: isPatientAppointment && hasPatient && canViewClinical">
        <mat-icon>assignment</mat-icon>
        Clinical Notes
      </button>
      <button mat-stroked-button (click)="sendSingleMessage()"
        *xuiPermissionRequired="'Clinical.Messages.Write'; condition: hasPatient">
        <mat-icon>sms</mat-icon>
        SMS
      </button>
      <button mat-stroked-button (click)="sendSingleEmail()"
        *xuiPermissionRequired="'Clinical.Emails.Write'; condition: hasPatient">
        <mat-icon>email</mat-icon>
        Email
      </button>
      <button mat-stroked-button (click)="createPatient()"
        *xuiPermissionRequired="'Clinical.Patients.Write'; condition: isPatientAppointment && !hasPatient">
        <mat-icon>person_add</mat-icon>
        Create Patient
      </button>
    </div>
  </div>
} @else {
  <h1 mat-dialog-title class="edit-header">
    <button mat-icon-button (click)="switchToDetail()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Edit Appointment</span>
  </h1>
  <mat-dialog-content>
    <app-appointment-edit-form
      [appointment]="data.appointment"
      [appointmentTypes]="data.appointmentTypes"
      (saved)="onSaved($event)"
      (cancelled)="switchToDetail()">
    </app-appointment-edit-form>
  </mat-dialog-content>
  <mat-dialog-actions class="mx-3 mb-2">
    <span class="flex-grow-1"></span>
    <button mat-button (click)="switchToDetail()" [disabled]="editForm?.saving">Cancel</button>
    <button mat-flat-button color="primary" (click)="triggerSave()" [disabled]="editForm?.saving">Save</button>
  </mat-dialog-actions>
}
